import React, { useState } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  Flex,
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@chakra-ui/react";

import { CustomButton } from "../../../../../components/CustomButton";
import { CustomSelectWField } from "../../../../../components/CustomSelectWField";
import { FocusError } from "../../../../../components/FocusError";
import CustomDropzone from "../../../../../components/CustomDropzone";
import {
  Permission,
  referenciaFunc,
} from "../../../../../../helpers/Funcionalidades";
import ConfirmationModal from "../../../Cadastrar/Movimentacao/ConfirmationModal";
import CriancaService from "../../../../../../main/services/CriancaService";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { useHistory } from "react-router-dom";
import { deleteUrlParam } from "../../../../../utils/deleteUrlParam";

export const GuardaModal = ({
  isOpen,
  onOpen,
  onClose,
  onCloseFiliacoes,
  form,
  filiacoes,
  setNovaFiliacao,
  initialFiliacao,
  roleKeycloack,
  idCrianca,
  fetchDataGuarda,
}) => {
  const [tipos, setTipos] = useState({ options: [], isLoading: false });
  const [relations, setRelations] = useState({ options: [], isLoading: false });
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [initialValues] = useState({
    nome: "",
    tipoTermoGuarda: "",
    anexoGuia: null,
  });
  const { cadastrarGuarda, setCadastrarGuarda } = useAppContext();
  const [selectedOption, setSelectedOption] = useState(null);
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];
  const history = useHistory();

  const backAlert = () => {
    if (cadastrarGuarda) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarGuarda(false);
        }
      });
    } else {
      onClose();
    }
  };
  const schema = Yup.object().shape({
    tipoTermoGuarda: Yup.object()
      .nullable()
      .required("Este campo é obrigatório!"),
    nome: Yup.object().nullable().required("Este campo é obrigatório!"),
    anexoGuia: Yup.mixed()
      .when("tipoTermoGuarda", {
        is: (tipoTermoGuarda) => tipoTermoGuarda?.id === 2,
        then: Yup.mixed().required("Este campo é obrigatório!"),
      })
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
  });

  const adicionarGuarda = async (id, valuesToSend) => {
    try {
      await CriancaService.postGuardaReferenciaFamiliar(id, valuesToSend);
      deleteUrlParam("idAnexo", history);
      Swal.fire({
        title: "Sucesso!",
        text: "Registro cadastrado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchDataGuarda();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error.response.data.message : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { nome, tipoTermoGuarda, anexoGuia } = values;

      if (anexoGuia) {
        CriancaService.postAnexoGuardaReferenciaFamiliar(
          idCrianca,
          anexoGuia
        ).then((res) => {
          const { idAnexo, idCrianca } = res.data;

          const valuesToSend = {
            idAnexo: idAnexo ? idAnexo : 0,
            idPessoaFisicaResponsavelGuarda: nome ? nome.id : "",
            tipoTermoGuarda:
              tipoTermoGuarda.id === 1 ? "GUARDA_DE_FATO" : "GUARDA_TUTELA",
          };

          if (idAnexo && idCrianca) {
            adicionarGuarda(idCrianca, valuesToSend);
          }
        });
      } else {
        const valuesToSend = {
          idAnexo: 0,
          idPessoaFisicaResponsavelGuarda: nome ? nome.id : "",
          tipoTermoGuarda:
            tipoTermoGuarda.id === 1 ? "GUARDA_DE_FATO" : "GUARDA_TUTELA",
        };
        adicionarGuarda(idCrianca, valuesToSend);
      }

      actions.setSubmitting(false);
    }, 200);
  };

  const handleGetRelacionamento = () => {
    setRelations({ ...relations, isLoading: true });

    CriancaService.getRelationamentosGuardaReferencia(idCrianca).then((res) => {
      const tempOptions = res.data.map((relation) => {
        return {
          id: relation.id,
          label: relation.nome,
        };
      });
      setRelations({ options: tempOptions, isLoading: false });
    });
  };

  const handleGetTipos = () => {
    setTipos({ ...tipos, isLoading: true });

    const tipos2 = [
      {
        id: 1,
        genero: "Guarda de fato",
        descricao:
          "Situação fática em que a criança ou adolescente se encontra sob os cuidados informais de alguém, que não possui decisão judicial de guarda. Nessas hipóteses, é necessário que o “guardião de fato” constitua advogado ou, não tendo condições financeiras, Defensor Público, visando à regularização da situação da criança ou adolescente, com a propositura da ação cabível.",
      },
      {
        id: 2,
        genero: "Guarda ou Tutela",
        descricao:
          "O guardião ou tutor é aquele que possui decisão judicial que o nomeia como responsável legal por criança ou adolescente, tendo como deveres legais os de cuidar, vigiar, criar, educar e tê-lo em sua companhia, sendo a guarda e a tutela oponíveis aos pais, caso vivos.",
      },
    ];
    const tempOptions = tipos2.map((tipo) => {
      return {
        id: tipo.id,
        label: tipo.genero,
        descricao: tipo.descricao,
      };
    });

    setTipos({ options: tempOptions, isLoading: false });
  };

  const handleConfirmAction = (props) => {
    props.setFieldValue("tipoTermoGuarda", selectedOption);

    setIsConfirmationModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {"Guarda".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <Form style={{ width: "100%" }}>
                  {setCadastrarGuarda(
                    hasFormChanged(initialValues, props.values)
                  )}
                  <FocusError />
                  <Grid templateColumns="repeat(5, 1fr)" gap="15px" w="100%">
                    <GridItem colSpan={{ base: 6, lg: 2 }}>
                      <CustomSelectWField
                        fieldName="tipoTermoGuarda"
                        label="Tipo*"
                        placeholder="Selecione o tipo"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.id}
                        defaultValue={props.values.tipoTermoGuarda}
                        isLoading={tipos.isLoading}
                        options={tipos.options}
                        onChange={(value) => {
                          if (value && value !== props.values.tipoTermoGuarda) {
                            setSelectedOption(value);
                            setIsConfirmationModalOpen(true);
                          } else {
                            props.setFieldValue(
                              "tipoTermoGuarda",
                              value ? value : ""
                            );
                          }
                        }}
                        onFocus={handleGetTipos}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 6, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="nome"
                        label="Nome*"
                        placeholder="Selecione o nome"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.id}
                        defaultValue={props.values.nome}
                        isLoading={relations.isLoading}
                        options={relations.options}
                        onChange={(value) => {
                          props.setFieldValue("nome", value ? value : "");
                        }}
                        onFocus={handleGetRelacionamento}
                      />
                    </GridItem>
                    {selectedOption?.id === 2 && (
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={referenciaFunc.guardaAnexar}
                      >
                        <GridItem colSpan={{ base: 6, lg: 2 }}>
                          <Flex>
                            <CustomDropzone
                              formProps={props}
                              title={`Anexar Decisão Judicial / Termo de Guarda ${
                                selectedOption?.id === 2 ? "*" : ""
                              }`}
                              fieldName="anexoGuia"
                              height="42px"
                              titleText="Informe o número da guia"
                            />
                          </Flex>
                        </GridItem>
                      </Permission>
                    )}
                  </Grid>
                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      <CustomButton onClick={backAlert} label="Cancelar" />
                      <CustomButton
                        type="submit"
                        translate="no"
                        isLoading={props.isSubmitting}
                        label="Salvar"
                      />
                    </SimpleGrid>
                  </Flex>

                  <ConfirmationModal
                    isOpen={isConfirmationModalOpen}
                    selectedOption={selectedOption}
                    onClose={() => setIsConfirmationModalOpen(false)}
                    onConfirm={() => handleConfirmAction(props)}
                    tipo={"guarda"}
                  />
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
